import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";
import { OGImage, OG_IMAGE_TYPES } from "../og-image";

const CarServiceHistoryMetaTags = ({
    history,
    meta = {}
}) => {
    const baseUrl = `${appUrl()}/`;
    const pageUrl = `${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`;
    const {
        og: { title: ogTitle = "", description: ogDescription = "" } = {},
        default: { title: defaultTitle = "", description: defaultDescription = "" } = {}
    } = meta || {};

    return (
        <React.Fragment>
            <Helmet>
                <title>{defaultTitle}</title>
                <meta name="title" content={defaultTitle} />
                <meta name="description" content={defaultDescription} />
                <meta property="og:title" content={ogTitle} />
                <meta property="og:description" content={ogDescription} />
                <meta property="og:url" content={`${pageUrl}`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CARS24" />
                <link href={pageUrl} rel="canonical" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content={`${baseUrl}`} />
                <meta property="twitter:url" content={pageUrl} />
                <meta name="twitter:title" content={defaultTitle} />
                <meta name="twitter:description" content={defaultDescription} />
            </Helmet>
            <OGImage type={OG_IMAGE_TYPES.servicehistory} />
        </React.Fragment>
    );
};

CarServiceHistoryMetaTags.propTypes = {
    history: PropTypes.object,
    meta: PropTypes.object
};

export default CarServiceHistoryMetaTags;

